import React, { useState, useEffect } from "react";
import { useMemberstack, } from "@memberstack/react";
import { useNavigate } from 'react-router-dom';
//img et icn
import {  InformationCircleIcon, StarIcon, CheckBadgeIcon } from "@heroicons/react/24/solid";
import AddressInput from "../components/AdresseInput";
import FaqOnboard from "../components/FaqOnboard";
import Berengere from "../img/notaire/berengere-bois-samier.webp";
import Nuno from "../img/notaire/nuno-monteiro-notaire-clotere.jpeg";



const includedFeatures = [
    'Accompagnement juridique jusqu’à la signature',
    'Sécurité et confidentialité de vos données',
    'Rapide grâce au process 100% en ligne',
    'Suivi et conseils personnalisés',
]


function FormContratMariage() {
    const memberstack = useMemberstack();
    const [member, setMember] = useState(null);
    const [marie, setMarie] = useState(null);
    const [prenom, setPrenom] = useState(null);
    const [nom, setNom] = useState(null);
    const [telephone, setTelephone] = useState(null);
    const [email, setEmail] = useState(null);
    const [selectedAddress, setSelectedAddress] = useState(null);
    const [adresse, setAdresse] = useState(null);
    const [bienImmo, setBienImmo] = useState(null);
    const [valeurImmo, setValeurImmo] = useState(null);
    //step
    const [step1, setStep1] = useState(true);
    const [step3, setStep3] = useState(false);
    const [step4, setStep4] = useState(false);
    const [step5, setStep5] = useState(false);
    const [stepEnd, setStepEnd] = useState(false);
    const [stepPaiement, setStepPaiement] = useState(false);
    const navigate = useNavigate();
    const { getCurrentMember } = useMemberstack();


    //set member if logged
    useEffect(() => {
        memberstack.getCurrentMember()
            .then(({ data: member }) => setMember(member))
    }, []);


    const handleSubmitCoordonnees = (event) => {
        event.preventDefault();
      
        const userData = {
          prenom: event.target.prenom.value,
          nom: event.target.nom.value,
          email: event.target.email.value,
          telephone: event.target.telephone.value,
          marie:marie,
          bienImmo:bienImmo,
          valeurImmo:valeurImmo
        };
      
        // Met à jour les states
        setPrenom(userData.prenom);
        setNom(userData.nom);
        setEmail(userData.email);
        setTelephone(userData.telephone);
      
        // Change d'étape
        setStep4(false);
        setStep5(true);
      
        // Envoie à Zapier avec les bonnes valeurs
        sendToZapier(userData);
      };

    const handleSubmitAdresse = (event) => {
        event.preventDefault();
        //console.log("adresse selectionné",selectedAddress)
        // Met à jour les states
        setAdresse(selectedAddress);
        
        // Change d'étape
        setStep5(false);
        setStepEnd(true);
        // Envoie à Zapier avec les bonnes valeurs
        sendToZapierUpdate(email, selectedAddress);

    }


    {/** on créer le lead zapier */}
    const sendToZapier = async (data) => {
        const zapierURL = "https://hooks.zapier.com/hooks/catch/7206204/2fywvbc/"; // 👈 Specify your Zapier Webhook URL here
        try {
            const response = await fetch(zapierURL, {
                method: "POST",
                mode: "cors",
                body: JSON.stringify(data)
            });
            const res = await response.json();
            console.log("Zapier success:", res);
        } catch (e) {
            console.log("Zapier error:", e);
        }
    };

    {/** on update le lead avec l'adresse */}
    const sendToZapierUpdate = async (email, selectedAddress) => {
        //console.log("selectedAddress dans zapier",selectedAddress)
        const zapierURL = "https://hooks.zapier.com/hooks/catch/7206204/2x6r4zu/"; // 👈 Specify your Zapier Webhook URL here
        try {
            const response = await fetch(zapierURL, {
                method: "POST",
                mode: "cors",
                body: JSON.stringify({ email, selectedAddress }), // ✅ CORRECT ici
            });
            const res = await response.json();
            console.log(res);
        } catch (e) {
            console.log(e);
        }
    };

    const handleOpenLoginModal = () => {
        navigate("/connexion");
    };

      useEffect(() => {
        const checkLogin = async () => {
          const { data: member } = await getCurrentMember();
          if (member) {
            memberstack.closeModal(); // 👈 ferme la modal
            navigate("/app/dashboard-mariage"); // 👈 redirige ensuite
          }
        };
      
        const interval = setInterval(checkLogin, 1000);
      
        return () => clearInterval(interval);
      }, []);

      console.log("selectedAddress",selectedAddress)

    return (
        <>
            <div className={`sm:mx-auto w-full  flex flex-col sm:items-center ${stepPaiement === true || stepEnd === true ? "" : "lg:max-w-xl"}`} >
                {/** q1 */}
                {step1 === true &&
                    <>
                        <div>
                            <p className="text-sm font-medium text-slate-500 mb-1">Question <span className="text-indigo-800">1</span>/5</p>
                            <h2 className="text-2xl/9 font-bold tracking-tight text-gray-900">Êtes-vous déjà mariés ?</h2>
                        </div>

                        <div className="sm:mt-10 w-full">
                            <ul className="grid gap-1 md:grid-cols-1 p-0">
                                <li>
                                    <input type="radio" id="oui" name="start" className="hidden peer" required onClick={() => { setMarie("oui"); setStep1(false); setStep3(true); }} />
                                    <label htmlFor="oui" className="radio-button">
                                        Oui
                                    </label>
                                </li>
                                <li>
                                    <input type="radio" id="non" name="start" className="hidden peer" required onClick={() => { setMarie("non"); setStep1(false); setStep3(true); }} />
                                    <label htmlFor="non" className="radio-button">
                                        Non, pas encore
                                    </label>
                                </li>
                            </ul>
                        </div>
                    </>
                }

                {/** bien immo */}
                {step3 === true &&
                    <>
                        <div>
                            <p className="text-sm font-medium text-slate-500 mb-1">Question <span className="text-indigo-800">2</span>/5</p>
                            <h2 className=" text-2xl/9 font-bold tracking-tight text-gray-900">Avez-vous des biens immobiliers à protéger</h2>
                        </div>

                        <div className="mt-10 w-full">

                            <ul className="grid w-full gap-1 md:grid-cols-1 p-0">
                                <li className="w-full">
                                    <input type="radio" id="oui" name="immo" className="hidden peer" required onClick={() => { setBienImmo("oui"); }} />
                                    <label htmlFor="oui" className="radio-button">
                                        Oui
                                    </label>
                                </li>
                                <li className="w-full">
                                    <input type="radio" id="non" name="immo" className="hidden peer" required onClick={() => { setBienImmo("non"); setStep3(false); setStep4(true); }} />
                                    <label htmlFor="non" className="radio-button">
                                        Non
                                    </label>
                                </li>
                            </ul>

                            {bienImmo === "oui" && <>
                                <h2 className="mt-10 text-2xl/9 font-bold tracking-tight text-gray-900">Quelle est la valeur de ce(s) bien(s) ?</h2>
                                <ul className="flex flex-col gap-2">
                                    <li>
                                        <input type="radio" id="moins30" name="immo" className="hidden peer" required onClick={() => { setValeurImmo("moins30"); setStep3(false); setStep4(true); }} />
                                        <label htmlFor="moins30" className="radio-button">
                                            Moins de 30 800€
                                        </label>
                                    </li>
                                    <li>
                                        <input type="radio" id="30200" name="immo" className="hidden peer" required onClick={() => { setValeurImmo("30200"); setStep3(false); setStep4(true); }} />
                                        <label htmlFor="30200" className="radio-button">
                                            Entre 30 800 et 200 000€
                                        </label>
                                    </li>
                                    <li>
                                        <input type="radio" id="200500" name="immo" className="hidden peer" required onClick={() => { setValeurImmo("200-500"); setStep3(false); setStep4(true); }} />
                                        <label htmlFor="200500" className="radio-button">
                                            Entre 200 000 et 500 000€
                                        </label>
                                    </li>
                                    <li>
                                        <input type="radio" id="plus500" name="immo" className="hidden peer" required onClick={() => { setValeurImmo("plus500"); setStep3(false); setStep4(true); }} />
                                        <label htmlFor="plus500" className="radio-button">
                                            Plus de 500 000€
                                        </label>
                                    </li>
                                </ul>
                            </>}
                        </div>
                    </>
                }

                {/** coordonnées */}
                {step4 === true &&
                    <>
                        <div>
                            <p className="text-sm font-medium text-slate-500 mb-1">Question <span className="text-indigo-800">3</span>/5</p>
                            <h2 className=" text-2xl/9 font-bold tracking-tight text-gray-900">Quelles sont vos coordonnées</h2>
                            <p className="text-sm text-slate-600">Pas d'inquiétude on ne les vendra pas ! C'est uniquement pour vous joindre facilement en cas de besoin.</p>
                        </div>
                        <form action="#" method="POST" className="w-full space-y-6" onSubmit={handleSubmitCoordonnees}>
                            <div className="grid sm:grid-cols-2 gap-3 w-full">
                                <div>
                                    <label className="block text-base font-medium text-gray-900"> Votre Nom<sup>*</sup></label>
                                    <input
                                        required
                                        name="nom"
                                        type="text"
                                        className="input-clotere"
                                    />
                                </div>
                                <div>
                                    <label className="block text-base font-medium text-gray-900">Votre Prénom<sup>*</sup> </label>
                                    <input
                                        required
                                        name="prenom"
                                        type="text"
                                        className="input-clotere"
                                    />
                                </div>
                            </div>
                            <div>
                                <label className="block text-base font-medium text-gray-900">
                                    Votre Email<sup>*</sup>
                                </label>
                                <div className="mt-2">
                                    <input
                                        required
                                        name="email"
                                        type="email"
                                        className="input-clotere"
                                    />
                                </div>
                            </div>
                            <div>
                                <label className="block text-base font-medium text-gray-900">
                                    Votre Téléphone<sup>*</sup>
                                </label>
                                <div className="mt-2">
                                    <input
                                        required
                                        name="telephone"
                                        type="text"
                                        className="input-clotere"
                                    />
                                </div>
                            </div>
                            <div>
                                <button
                                    type="submit"
                                    className="btn-indigo no-underline p-4"
                                >
                                    Continuer
                                </button>
                            </div>
                        </form>


                    </>
                }

                {/** adresse */}
                {step5 === true &&
                    <>
                        <div>
                            <p className="text-sm font-medium text-slate-500 mb-1">Question <span className="text-indigo-800">4</span>/5</p>
                            <h2 className=" text-2xl/9 font-bold tracking-tight text-gray-900">Quelle est votre adresse ?</h2>
                        </div>

                        <div className="mt-10 w-full">
                            <form action="#" method="POST" className="space-y-6 w-full" onSubmit={handleSubmitAdresse}>
                                <div>
                                    <label className="block text-base font-medium text-gray-900">
                                        Adresse<sup>*</sup>
                                    </label>
                                    <AddressInput className="input-clotere" onAddressSelect={(place) => setSelectedAddress(place)} />
                                </div>
                                <div>
                                    <button
                                        type="submit"
                                        className="btn-indigo  no-underline  p-4"
                                    >
                                        Continuer
                                    </button>
                                </div>
                            </form>
                        </div>
                    </>
                }



                {/** etape choix notaire */}
                {stepEnd === true &&
                    <>
                        <div className="text-center">
                        <div class="text-center py-4 lg:px-4">

                        {(valeurImmo === "moins30" || bienImmo === "non") && (
                            <>
                                <div className="relative group inline-block">
                                <div class="group p-2 px-4 bg-indigo-600 items-center text-indigo-100 leading-none lg:rounded-full flex lg:inline-flex" role="alert">
                                    <span class="font-semibold mr-2 text-left flex-auto">Le tarif de votre contrat de mariage sera de 369€ </span>
                                    <InformationCircleIcon className="size-6"/>
                                </div>

                                <div className="absolute left-full top-1/2 -translate-y-1/2 ml-2 hidden group-hover:block bg-indigo-800 text-white text-sm px-2 py-1 rounded shadow-md whitespace-nowrap z-10">
                                    Ce montant est a réglé après le <br/>1er rendez-vous avec votre notaire.
                                </div>
                            </div>
                            </>
                        )}

                        {bienImmo === "oui" && valeurImmo !== "moins30" && (
                        <>
                            <div className="relative group inline-block">
                                <div class="group p-2 px-4 bg-indigo-600 items-center text-indigo-100 leading-none lg:rounded-full flex lg:inline-flex" role="alert">
                                    <span class="font-semibold mr-2 text-left flex-auto">Le tarif de votre contrat de mariage sera de 369€ + honoraires de votre notaire </span>
                                    <InformationCircleIcon className="size-6"/>
                                </div>
                                <p className="mb-0 text-xs">Ces honoraires sont proportionnelles au montant des apports des époux</p>

                                <div className="absolute left-full top-1/2 -translate-y-1/2 ml-2 hidden group-hover:block bg-indigo-800 text-white text-sm px-2 py-1 rounded shadow-md whitespace-nowrap z-10">
                                    Ce montant est a réglé après le <br/>1er rendez-vous avec votre notaire.
                                </div>
                            </div>
                        </>
                        )}
                            
                            
                            
                            </div>
                            <h2 as="h3" className=" text-2xl/9 font-bold tracking-tight text-gray-900">
                                🥳 Deux notaires sont disponibles pour votre contrat de mariage.
                            </h2>
                            
                            <p></p>
                            <div className="flow-root relative my-3">
                                <div className="flex flex-col sm:flex-row gap-12 ">
                                    {/** notaire 1 */}
                                    <div className="rounded-lg bg-gray-50 ring-1 shadow-xs ring-gray-900/5">
                                        <dl className="flex flex-wrap items-center">
                                            <div className="flex-none self-end px-6 pt-4">
                                                <img className="rounded-full size-24" src={Berengere} alt="notaire" />
                                            </div>
                                            <div className="flex-auto pt-6 pl-6 text-left">
                                            <span className="bg-gradient-to-r from-teal-200 to-teal-500 inline-flex items-center rounded-md px-2 py-1 text-sm font-medium text-gray-600 ring-1 ring-gray-500/10 ring-inset">
                                                    Notaire recommandé
                                                </span>
                                                <a href={"https://clotere.fr/notaire/b%C3%A9reng%C3%A8re-bois-samier"} target="blank" className="no-underline"> <dt className="text-xl font-semibold text-gray-900">Maitre Bérengère Bois-Samier</dt></a>
                                                {/**<p className="text-sm flex flex-row mb-0 items-center">
                                                <MapPinIcon aria-hidden="true" className="h-6 w-5 text-gray-400" />
                                                20 rue Joseph Serlin 69001 LYON
                                                </p>*/}
                                            </div>

                                            

                                            <div className="flex flex-wrap gap-2 w-full flex-none gap-x-4 border-t border-gray-900/5 px-6 pt-6">
                                                <span className="inline-flex items-center rounded-md bg-slate-100 p-2 text-sm font-medium text-gray-600 ring-1 ring-gray-500/10 ring-inset">
                                                    Droit de la famille
                                                </span>
                                                <span className="inline-flex items-center rounded-md bg-slate-100 p-2 text-sm font-medium text-gray-600 ring-1 ring-gray-500/10 ring-inset">
                                                    Droit Immobilier
                                                </span>
                                            </div>
                                            {/**
                                            <div className="flex flex-wrap gap-2 w-full flex-none gap-x-4 border-t border-gray-900/5 px-6 pt-6">
                                                <div className="rounded-md bg-blue-50 p-2">
                                                    <div className="flex">
                                                        <div className="shrink-0">
                                                            <InformationCircleIcon aria-hidden="true" className="size-5 text-blue-400" />
                                                        </div>
                                                        <div className="ml-3 flex-1 md:flex md:justify-between">
                                                            <p className="text-sm text-blue-700 m-0 text-left">
                                                                Reçoit également en rendez-vous à Paris et Lyon
                                                            </p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                             */}

                                        </dl>
                                    </div>

                                    {/**notaire 2 */}
                                    <div className="rounded-lg bg-gray-50 ring-1 shadow-xs ring-gray-900/5">
                                        <dl className="flex flex-wrap items-center">
                                            <div className="flex-none self-end px-6 pt-4">
                                                <img className="rounded-full size-24" src={Nuno} alt="notaire" />
                                            </div>
                                            <div className="flex-auto pt-6 pl-6 text-left">
                                            <span className="bg-gradient-to-r from-teal-200 to-teal-500 inline-flex items-center rounded-md px-2 py-1 text-sm font-medium text-gray-600 ring-1 ring-gray-500/10 ring-inset">
                                                    Notaire recommandé
                                                </span>
                                                <a href={"https://clotere.fr/notaire/nuno-monteiro"} target="blank" className="no-underline"> <dt className="text-xl font-semibold text-gray-900">Maitre Nuno Monteiro</dt></a>
                                                
                                                {/**<p className="text-sm flex flex-row mb-0 items-center">
                                                <MapPinIcon aria-hidden="true" className="h-6 w-5 text-gray-400" />
                                                50 Avenue du bac 94210 LA VARENNE ST HILAIRE
                                                </p>**/}
                                            </div>

                                            <div className="flex flex-wrap gap-2 w-full flex-none gap-x-4 border-t border-gray-900/5 px-6 pt-6">
                                                <span className="inline-flex items-center rounded-md bg-slate-100 p-2 text-sm font-medium text-gray-600 ring-1 ring-gray-500/10 ring-inset">
                                                    Droit de la famille
                                                </span>
                                                <span className="inline-flex items-center rounded-md bg-slate-100 p-2 text-sm font-medium text-gray-600 ring-1 ring-gray-500/10 ring-inset">
                                                    Droit Immobilier
                                                </span>
                                            </div>
                                            {/**
                                            <div className="flex flex-wrap gap-2 w-full flex-none gap-x-4 border-t border-gray-900/5 px-6 pt-6">
                                                <div className="rounded-md bg-blue-50 p-2">
                                                    <div className="flex">
                                                        <div className="shrink-0">
                                                            <InformationCircleIcon aria-hidden="true" className="size-5 text-blue-400" />
                                                        </div>
                                                        <div className="ml-3 flex-1 md:flex md:justify-between">
                                                            <p className="text-sm text-blue-700 m-0 text-left">
                                                                Reçoit également en rendez-vous à Paris et Toulouse
                                                            </p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                             */}

                                        </dl>
                                    </div>

                                </div>
                            </div>
                            <button
                            onClick={() => {
                                handleOpenLoginModal();
                            }}
                            className="btn-indigo  p-3 no-underline w-auto mx-auto"
                            >
                            Me connecter et choisir mon notaire
                            </button>
                            <input type="email" data-ms-member="email" value={email} readOnly hidden />
                        </div>
                    </>
                }


                {/** etape paiement */}
                {stepPaiement === true &&
                    <>
                        <div className="mx-auto  px-6 lg:px-8">
                            <h2 className="font-bold text-center">Votre contrat de mariage simplifié et sécurisé</h2>
                            <p className="text-base/7 text-gray-600 text-center">
                                Clotere.fr simplifie la création de votre dossier notarial et vous connecte à un notaire réactif pour un traitement rapide.
                            </p>

                            <div className="mx-auto  rounded-3xl ring-1 ring-gray-200 lg:mx-0 lg:flex lg:max-w-none">
                                <div className="p-8 sm:p-10 lg:flex-auto">
                                    <div className="flex-row">

                                        <div className="flex items-center gap-x-4">
                                            <h4 className="flex-none text-sm/6 font-semibold ">Ce qui est inclus</h4>
                                            <div className="h-px flex-auto bg-gray-100" />
                                        </div>
                                    </div>

                                    <ul role="list" className="pl-0 grid grid-cols-1 gap-4 text-sm/6 text-gray-600 sm:grid-cols-2 sm:gap-6">
                                        {includedFeatures.map((feature) => (
                                            <li key={feature} className="flex gap-x-3 font-bold">
                                                <CheckBadgeIcon aria-hidden="true" className="h-6 w-5 flex-none text-indigo-600" />
                                                {feature}
                                            </li>
                                        ))}
                                    </ul>
                                    <figure className="mx-auto max-w-2xl bg-slate-50 rounded-md p-4 mt-10">
                                        <div className="flex gap-x-1 text-indigo-600">
                                            <StarIcon aria-hidden="true" className="size-5 flex-none" />
                                            <StarIcon aria-hidden="true" className="size-5 flex-none" />
                                            <StarIcon aria-hidden="true" className="size-5 flex-none" />
                                            <StarIcon aria-hidden="true" className="size-5 flex-none" />
                                            <StarIcon aria-hidden="true" className="size-5 flex-none" />
                                        </div>
                                        <blockquote className="text-xl font-semibold tracking-tight text-gray-900 mb-0">
                                            <p className="mb-0">
                                                “L'équipe est vraiment top, le service client que j'ai reçu de leur part a parfaitement répondu à mes attentes. Merci”
                                            </p>
                                        </blockquote>
                                        <figcaption className="flex items-center gap-x-6">

                                            <div className="text-sm/6">
                                                <div className="font-regular text-gray-900">Aurore, <span className="font-regular text-gray-600">A réalisé son contrat de mariage sur Clotere</span></div>

                                            </div>
                                        </figcaption>
                                    </figure>
                                </div>

                                <div className="-mt-2 p-2 lg:mt-0 lg:w-full lg:max-w-md lg:shrink-0">
                                    <div className="rounded-2xl bg-gray-50 py-10 text-center ring-1 ring-inset ring-gray-900/5 lg:flex lg:flex-col lg:justify-center lg:py-16">
                                        <div className="mx-auto max-w-xs px-8">

                                            <p className="mt-6 flex items-baseline justify-center gap-x-2">
                                                <span className="text-5xl font-semibold tracking-tight text-gray-900">369€</span>

                                            </p>
                                            <a
                                                href={"https://buy.stripe.com/cN2cOK2RLe7zbTycMO?prefilled_email=" + email}
                                                className="no-underline mt-10 block w-full rounded-md bg-indigo-600 px-3 py-2 text-center text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                                            >
                                                Valider mon offire
                                            </a>
                                            <p className="mt-6 text-xs/5 text-gray-600">
                                                Paiement 100% sécurisé via notre partenaire Stripe
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <FaqOnboard type="mariage" />
                        </div>
                    </>
                }
            </div>
        </>
    );
}


export default FormContratMariage;